/* @jsx mdx */
  import React from 'react'
  import { mdx } from '@mdx-js/react'
  /* @jsx mdx */
import { Playground, Props } from 'docz'
import Textarea from './'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "textarea"
    }}>{`Textarea`}</h1>
    <Playground __position={0} __code={'<Textarea />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Textarea
    }} mdxType="Playground">
    <Textarea mdxType="Textarea" />
    </Playground>
    <h3 {...{
      "id": "proptypes"
    }}>{`PropTypes`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Prop`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`TextInput props`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "/typography/textInput"
            }}>{`TextInput`}</a></td>
        </tr>
      </tbody>
    </table>
    </MDXLayout>;
}

MDXContent.isMDXComponent = true;
  